// extracted by mini-css-extract-plugin
module.exports = {"simple-button-wrapper":"SimpleButton_simple-button-wrapper__2d51P"};